import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { alertActions, patientActions } from '_actions';
import ReactDatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { getDateMDYYYY } from '_helpers';
import styles from './DBDateField.module.css'

class DBDateFieldDiagOnset extends React.Component {

    handleValueChange(date) {
        let minDate = this.props.minDate ? new Date(this.props.minDate) : new Date('1900/01/01');
        let maxDate = this.props.maxDate ? new Date(this.props.maxDate) : new Date('2100/01/01');
        if (date === null) {
            this.props.updateDiagOnset(this.props.epno, this.props.position, this.props.type, '');
        }
        else if (date instanceof Date === false) {
            this.props.updateDiagOnset(this.props.epno, this.props.position, this.props.type, '');
            this.props.alertWarning('The date value was invalid.');
        }
        else if (date.getTime() < minDate.getTime() || date.getTime() > maxDate.getTime()) {
            this.props.updateDiagOnset(this.props.epno, this.props.position, this.props.type, '');
            let customMsg = this.props.customMsg ? this.props.customMsg : undefined;
            if (!customMsg) {
                if (minDate.getTime() === new Date('1900/01/01').getTime() && maxDate.getTime() !== new Date('2100/01/01').getTime()) {
                    customMsg = '  The date must be ' + getDateMDYYYY(maxDate) + ' or earlier.';
                }
                else if (minDate.getTime() !== new Date('1900/01/01').getTime() && maxDate.getTime() === new Date('2100/01/01').getTime()) {
                    customMsg = '  The date must be ' + getDateMDYYYY(minDate) + ' or after.';
                }
                else {
                    customMsg = '  The date must be in the range of 1/1/1900 to 1/1/2100.';
                }
                customMsg = 'The date was not in the valid range.' + customMsg;
            }

            this.props.alertWarning(customMsg);
        }
        else {
            this.props.updateDiagOnset(this.props.epno, this.props.position, this.props.type, date);
        }
    }

    render() {
        return (
            <div className={styles.wrapper}>
                <span className={styles.icon}>
                    <FontAwesomeIcon icon={faCalendarAlt} />
                </span>
                <ReactDatePicker
                    className={styles.picker}
                    selected={this.props.value}
                    onChange={(date) => this.handleValueChange(date)}
                    placeholderText='m/d/yyyy'
                    dateFormat='M/d/yyyy'
                    todayButton='Today'
                />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateDiagOnset: bindActionCreators(patientActions.updateDiagOnset, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let value = state.entities.diagnosis[ownprops.id] && state.entities.diagnosis[ownprops.id].onset ?
        new Date(state.entities.diagnosis[ownprops.id].onset) : '';
    let epno = state.entities.diagnosis[ownprops.id].epno;
    let position = state.entities.diagnosis[ownprops.id].position;
    let type = state.entities.diagnosis[ownprops.id].type;

    return {
        value,
        epno,
        position,
        type
    };
}

const connectedDBDateFieldDiagOnset = connect(mapStateToProps, mapDispatchToProps)(DBDateFieldDiagOnset);
export { connectedDBDateFieldDiagOnset as DBDateFieldDiagOnset };